(function () {
  'use strict';

  /* ============================================================
     UTILITIES
  ============================================================ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function lockScroll()   { document.body.style.overflow = 'hidden'; }
  function unlockScroll() { document.body.style.overflow = ''; }

  /* ============================================================
     MODE (Day / Night)
  ============================================================ */
  var MODE_KEY = 'krauno-mode';

  function getMode() { return localStorage.getItem(MODE_KEY) || 'day'; }

  function applyMode(mode) {
    if (mode === 'night') {
      document.documentElement.classList.add('night-mode');
    } else {
      document.documentElement.classList.remove('night-mode');
    }
    localStorage.setItem(MODE_KEY, mode);
    updateModeUI(mode);
    closeHotspotDrawer();
  }

  function updateModeUI(mode) {
    document.querySelectorAll('[data-day-label],[data-night-label]').forEach(function (el) {
      el.textContent = mode === 'night'
        ? (el.dataset.nightLabel || el.dataset.dayLabel)
        : el.dataset.dayLabel;
    });
    resetCarouselDots();
  }

  /* ============================================================
     HEADER: scroll effect
  ============================================================ */
  function initHeader() {
    var header = document.getElementById('krauno-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ============================================================
     MOBILE MENU
  ============================================================ */
  function initMobileMenu() {
    var btn  = document.getElementById('k-menu-btn');
    var menu = document.getElementById('k-mobile-menu');
    if (!btn || !menu) return;

    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('open');
      btn.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', open);
    });

    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('open');
        btn.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ============================================================
     MOBILE MENU — COLLAPSIBLE SUB-ITEMS
     Each .k-mobile-sub starts hidden; the chevron button alongside
     the parent link toggles it open/closed.
  ============================================================ */
  function initMobileSubmenus() {
    document.querySelectorAll('.k-mobile-sub-toggle').forEach(function (btn) {
      var row = btn.closest('.k-mobile-nav-row');
      if (!row) return;
      var sub = row.nextElementSibling;
      if (!sub || !sub.classList.contains('k-mobile-sub')) return;

      btn.addEventListener('click', function () {
        var isOpen = sub.classList.toggle('open');
        btn.classList.toggle('open', isOpen);
        btn.setAttribute('aria-expanded', String(isOpen));
        sub.setAttribute('aria-hidden', String(!isOpen));
      });
    });
  }

  /* ============================================================
     DROPDOWN NAVIGATION
     JS-driven hover with a small close-delay so the gap between
     the nav link and the dropdown panel doesn't kill the state.
  ============================================================ */
  function initDropdowns() {
    // :not([data-dd-init]) prevents duplicate listeners when called on section:load
    document.querySelectorAll('.k-nav-item.has-dropdown:not([data-dd-init])').forEach(function (item) {
      item.setAttribute('data-dd-init', '1');
      var dropdown = item.querySelector('.k-dropdown');
      if (!dropdown) return;
      var closeTimer;

      function open() {
        clearTimeout(closeTimer);
        item.classList.add('is-open');
      }
      function scheduledClose() {
        closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, 120);
      }

      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', scheduledClose);

      // Keyboard: open on focus of the parent link
      var link = item.querySelector('.k-nav-link');
      if (link) {
        link.addEventListener('focus', open);
        link.addEventListener('blur', function () {
          // Delay to allow focus to move inside the dropdown
          setTimeout(function () {
            if (!item.querySelector(':focus')) item.classList.remove('is-open');
          }, 150);
        });
      }

      // Close when clicking outside
      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) item.classList.remove('is-open');
      });
    });
  }

  /* ============================================================
     MODE TOGGLE BUTTON
  ============================================================ */
  function initModeToggle() {
    var btn = document.getElementById('k-mode-toggle');
    if (!btn) return;
    btn.addEventListener('click', function () {
      applyMode(getMode() === 'day' ? 'night' : 'day');
    });
  }

  /* ============================================================
     SCROLL ANIMATIONS (Intersection Observer)
  ============================================================ */
  function makeAllVisible() {
    document.querySelectorAll('.k-product-card, .k-stat-card, .k-trust-item, .k-room-canvas').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  function initScrollAnimations() {
    if (window.Shopify && Shopify.designMode) {
      makeAllVisible();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var delay = parseFloat(e.target.dataset.animDelay || 0) * 1000;
        setTimeout(function () { e.target.classList.add('visible'); }, delay);
        io.unobserve(e.target);
      });
    }, { threshold: 0.05, rootMargin: '60px 0px' });

    document.querySelectorAll('.k-product-card').forEach(function (el, i) {
      el.dataset.animDelay = (i % 3) * 0.1;
      io.observe(el);
    });
    document.querySelectorAll('.k-stat-card, .k-trust-item, .k-room-canvas').forEach(function (el) {
      io.observe(el);
    });
  }

  /* ============================================================
     STAT COUNTER ANIMATION
  ============================================================ */
  function initStatsCounters() {
    var els = document.querySelectorAll('[data-count-to]');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        animateCount(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 });

    els.forEach(function (el) { io.observe(el); });
  }

  function animateCount(el) {
    var target   = parseInt(el.dataset.countTo, 10);
    var duration = 2000;
    var steps    = 60;
    var step     = 0;
    var t = setInterval(function () {
      step++;
      if (step >= steps) { el.textContent = target; clearInterval(t); }
      else                { el.textContent = Math.round((target / steps) * step); }
    }, duration / steps);
  }

  /* ============================================================
     INTERACTIVE ROOM HOTSPOTS
  ============================================================ */
  var activeHotspot = null;

  function isMobile() { return window.innerWidth < 768; }

  function closeHotspotDrawer() {
    var drawer   = document.getElementById('k-hs-drawer');
    var backdrop = document.getElementById('k-hs-backdrop');
    var modal    = document.getElementById('k-mob-modal');
    if (drawer)   drawer.classList.remove('open');
    if (backdrop) backdrop.classList.remove('open');
    if (modal && modal.classList.contains('open')) {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }
    if (activeHotspot) { activeHotspot.classList.remove('active'); activeHotspot = null; }
  }

  function openMobileModal(hotspot) {
    var modal = document.getElementById('k-mob-modal');
    if (!modal) return;

    var nameEl  = modal.querySelector('[data-mob-name]');
    var priceEl = modal.querySelector('[data-mob-price]');
    var descEl  = modal.querySelector('[data-mob-desc]');
    var linkEl  = modal.querySelector('[data-mob-link]');
    var img     = modal.querySelector('.k-mob-modal-img');
    var ph      = modal.querySelector('.k-mob-modal-img-ph');

    if (nameEl)  nameEl.textContent  = hotspot.dataset.name  || '';
    if (priceEl) priceEl.textContent = hotspot.dataset.price || '';
    if (descEl)  descEl.textContent  = hotspot.dataset.desc  || '';

    if (linkEl) {
      linkEl.href = hotspot.dataset.productUrl || '#';
      var labelEl = linkEl.querySelector('.k-mob-modal-btn-label');
      if (labelEl) labelEl.textContent = hotspot.dataset.btnText || 'View Product';
    }

    var hasImg = !!(hotspot.dataset.img && hotspot.dataset.img.trim().length > 0);
    if (img) {
      img.src           = hotspot.dataset.img || '';
      img.alt           = hotspot.dataset.name || '';
      img.style.display = hasImg ? '' : 'none';
    }
    if (ph) ph.style.display = hasImg ? 'none' : '';

    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();
  }

  function initHotspots() {
    var drawer   = document.getElementById('k-hs-drawer');
    var closeBtn = document.getElementById('k-hs-close');
    var backdrop = document.getElementById('k-hs-backdrop');
    var mobModal = document.getElementById('k-mob-modal');
    var mobClose = document.getElementById('k-mob-modal-close');
    var mobBd    = document.getElementById('k-mob-modal-bd');

    if (backdrop) backdrop.addEventListener('click', closeHotspotDrawer);
    if (mobClose) mobClose.addEventListener('click', closeHotspotDrawer);
    if (mobBd)    mobBd.addEventListener('click', closeHotspotDrawer);

    document.querySelectorAll('.k-hotspot').forEach(function (hotspot) {
      var btn = hotspot.querySelector('.k-hs-btn');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (activeHotspot === hotspot) { closeHotspotDrawer(); return; }
        if (activeHotspot) activeHotspot.classList.remove('active');
        hotspot.classList.add('active');
        activeHotspot = hotspot;

        if (isMobile()) {
          openMobileModal(hotspot);
          return;
        }

        if (!drawer) return;

        // Text fields
        var nameEl  = drawer.querySelector('[data-hs-name]');
        var descEl  = drawer.querySelector('[data-hs-desc]');
        var priceEl = drawer.querySelector('[data-hs-price]');
        if (nameEl)  nameEl.textContent  = hotspot.dataset.name  || '';
        if (descEl)  descEl.textContent  = hotspot.dataset.desc  || '';
        if (priceEl) priceEl.textContent = hotspot.dataset.price || '';

        // Large product image + placeholder visibility
        var img         = drawer.querySelector('.k-hs-img');
        var placeholder = drawer.querySelector('.k-hs-img-placeholder');
        var hasImg      = !!(hotspot.dataset.img && hotspot.dataset.img.trim().length > 0);
        if (img) {
          img.src           = hotspot.dataset.img || '';
          img.alt           = hotspot.dataset.name || '';
          img.style.display = hasImg ? '' : 'none';
        }
        if (placeholder) placeholder.style.display = hasImg ? 'none' : '';

        // View product link + customisable button label
        var viewLink = drawer.querySelector('[data-hs-link]');
        if (viewLink) {
          viewLink.href = hotspot.dataset.productUrl || '#';
          var labelEl = viewLink.querySelector('.k-hs-btn-label');
          if (labelEl) labelEl.textContent = hotspot.dataset.btnText || 'View Product';
        }

        drawer.classList.add('open');
        if (backdrop) backdrop.classList.add('open');
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeHotspotDrawer);
    document.addEventListener('click', function (e) {
      if (!drawer || !drawer.classList.contains('open')) return;
      if (activeHotspot && activeHotspot.contains(e.target)) return;
      if (drawer.contains(e.target)) return;
      closeHotspotDrawer();
    });
  }

  /* ============================================================
     MOBILE CAROUSEL DOTS
  ============================================================ */
  function resetCarouselDots() {
    document.querySelectorAll('.k-carousel-dots .k-dot').forEach(function (d, i) {
      d.classList.toggle('active', i === 0);
    });
  }

  function initCarouselDots() {
    document.querySelectorAll('.k-product-scroll').forEach(function (scroll) {
      var set  = scroll.closest('.k-products-set');
      var dots = set ? set.querySelectorAll('.k-dot') : [];
      scroll.addEventListener('scroll', function () {
        var idx = Math.round(scroll.scrollLeft / (280 + 16));
        dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
      }, { passive: true });
      if (dots[0]) dots[0].classList.add('active');
    });
  }

  /* ============================================================
     SCROLL TO SECTION (Hero CTA)
  ============================================================ */
  function initHeroCTA() {
    document.querySelectorAll('[data-scroll-to]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById(btn.dataset.scrollTo);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  /* ============================================================
     SEARCH MODAL
  ============================================================ */
  function initSearch() {
    var modal    = document.getElementById('k-search-modal');
    var input    = document.getElementById('k-search-input');
    var results  = document.getElementById('k-search-results');
    var openBtn  = document.getElementById('k-search-btn');
    var closeBtn = document.getElementById('k-search-close');
    var backdrop = document.getElementById('k-search-backdrop');

    if (!modal || !openBtn) return;

    var searchTimer;

    function openSearch() {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll();
      setTimeout(function () { if (input) input.focus(); }, 80);
    }

    function closeSearch() {
      modal.classList.remove('open');
      modal.setAttribute('aria-hidden', 'true');
      unlockScroll();
      if (results) { results.innerHTML = ''; results.classList.remove('has-results'); }
      if (input)   { input.value = ''; }
    }

    openBtn.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) closeSearch();
    });

    if (input && results) {
      input.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var q = input.value.trim();
        if (q.length < 2) {
          results.innerHTML = '';
          results.classList.remove('has-results');
          return;
        }
        searchTimer = setTimeout(function () { runSearch(q); }, 280);
      });
    }

    function runSearch(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q)
              + '&resources[type]=product&resources[limit]=7';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderSearchResults(products, q);
        })
        .catch(function () {
          results.innerHTML = '<div class="k-search-msg">Something went wrong — please try again.</div>';
          results.classList.add('has-results');
        });
    }

    function renderSearchResults(products, q) {
      if (!products.length) {
        results.innerHTML = '<div class="k-search-msg">No products found for "<strong>' + escHtml(q) + '</strong>"</div>';
        results.classList.add('has-results');
        return;
      }
      var html = products.map(function (p) {
        var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        var imgHtml = imgUrl
          ? '<img src="' + escHtml(imgUrl) + '" alt="' + escHtml(p.title || '') + '" loading="lazy">'
          : '';
        var price = p.price ? formatMoney(p.price) : '';
        return '<a href="' + escHtml(p.url || '/') + '" class="k-search-result-item">'
          + '<div class="k-search-result-img">' + imgHtml + '</div>'
          + '<div>'
          +   '<div class="k-search-result-name">'  + escHtml(p.title || '') + '</div>'
          +   (price ? '<div class="k-search-result-price">' + price + '</div>' : '')
          + '</div>'
          + '</a>';
      }).join('');
      results.innerHTML = html;
      results.classList.add('has-results');
    }
  }

  /* ============================================================
     ACCOUNT PANEL
  ============================================================ */
  function initAccountPanel() {
    var panel    = document.getElementById('k-account-panel');
    var openBtn  = document.getElementById('k-account-btn');
    var closeBtn = document.getElementById('k-account-close');
    var backdrop = document.getElementById('k-account-backdrop');

    if (!panel || !openBtn) return;

    function openPanel() {
      panel.classList.add('open');
      panel.setAttribute('aria-hidden', 'false');
      lockScroll();
    }
    function closePanel() {
      panel.classList.remove('open');
      panel.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }

    openBtn.addEventListener('click', openPanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    if (backdrop) backdrop.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('open')) closePanel();
    });
  }

  /* ============================================================
     CART DRAWER
  ============================================================ */
  function initCartDrawer() {
    var drawer   = document.getElementById('k-cart-drawer');
    var openBtn  = document.getElementById('k-cart-btn');
    var closeBtn = document.getElementById('k-cart-close');
    var backdrop = document.getElementById('k-cart-backdrop');
    var body     = document.getElementById('k-cart-body');
    var totalEl  = document.getElementById('k-cart-total-amount');
    var footer   = document.getElementById('k-cart-footer');

    if (!drawer) return;

    function openDrawer() {
      renderCart();
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll();
    }
    function closeDrawer() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      unlockScroll();
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });

    function renderCart() {
      if (!body) return;
      body.innerHTML = '<div class="k-cart-loading">Loading…</div>';

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartBadge(cart.item_count);
          if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

          if (footer) {
            footer.style.display = cart.items && cart.items.length ? '' : 'none';
          }

          if (!cart.items || !cart.items.length) {
            body.innerHTML =
              '<div class="k-cart-empty">'
              + '<svg width="48" height="48" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" aria-hidden="true">'
              +   '<path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>'
              + '</svg>'
              + '<p class="k-cart-empty-title">Your cart is empty</p>'
              + '<span class="k-cart-empty-sub">Add some items to get started</span>'
              + '</div>';
            return;
          }

          body.innerHTML = cart.items.map(function (item) {
            var imgHtml = item.featured_image
              ? '<img src="' + escHtml(item.featured_image.url) + '" alt="' + escHtml(item.title || '') + '" loading="lazy">'
              : '';
            var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
            return '<div class="k-cart-item" data-key="' + escHtml(item.key) + '">'
              + '<div class="k-cart-item-img">' + imgHtml + '</div>'
              + '<div class="k-cart-item-body">'
              +   '<div class="k-cart-item-name">' + escHtml(item.product_title || item.title || '') + '</div>'
              +   (variant ? '<div class="k-cart-item-variant">' + escHtml(variant) + '</div>' : '')
              +   '<div class="k-cart-item-row">'
              +     '<span class="k-cart-item-price">' + formatMoney(item.line_price) + '</span>'
              +     '<div class="k-qty-control">'
              +       '<button class="k-qty-btn" data-key="' + escHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" type="button" aria-label="Decrease quantity">−</button>'
              +       '<span class="k-qty-val">' + item.quantity + '</span>'
              +       '<button class="k-qty-btn" data-key="' + escHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" type="button" aria-label="Increase quantity">+</button>'
              +     '</div>'
              +   '</div>'
              +   '<button class="k-cart-remove" data-key="' + escHtml(item.key) + '" data-qty="0" type="button">Remove</button>'
              + '</div>'
              + '</div>';
          }).join('');
        })
        .catch(function () {
          if (body) body.innerHTML = '<div class="k-cart-loading">Could not load cart.</div>';
        });
    }

    // Qty + remove (event delegation on body)
    if (body) {
      body.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-qty]');
        if (!btn) return;
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        changeCartItem(key, qty, renderCart);
      });
    }

    // Expose so initCart can refresh drawer after add-to-cart
    window._kraunoRenderCart = renderCart;

    // Initial badge sync
    refreshCartBadge();
  }

  function changeCartItem(key, qty, cb) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        if (cb) cb();
      })
      .catch(function () {});
  }

  function updateCartBadge(count) {
    var badge = document.getElementById('k-cart-count');
    if (!badge) return;
    badge.textContent = count;
    badge.classList.toggle('has-items', count > 0);
  }

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBadge(cart.item_count); })
      .catch(function () {});
  }

  /* ============================================================
     ADD TO CART (AJAX)
  ============================================================ */
  function initAddToCart() {
    refreshCartBadge();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      var variantId = btn.dataset.variantId;
      if (!variantId) {
        var productUrl = btn.dataset.productUrl;
        if (productUrl) window.location.href = productUrl;
        return;
      }

      var label = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          refreshCartBadge();
          // Refresh the cart drawer contents if it's open
          if (window._kraunoRenderCart) window._kraunoRenderCart();
          setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 2000);
        })
        .catch(function () { btn.innerHTML = label; btn.disabled = false; });
    });
  }

  /* ============================================================
     HTML ESCAPE HELPER
  ============================================================ */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ============================================================
     PRODUCT CATALOG — featured card + carousel navigation
     direction: 1 = forward (next/right), -1 = backward (prev/left), 0 = no animation
  ============================================================ */
  function initProductCatalogs() {
    document.querySelectorAll('[data-catalog]').forEach(function (wrap) {
      if (wrap.dataset.catalogInit) return;
      wrap.dataset.catalogInit = '1';

      var featAnchor = wrap.querySelector('[data-feat-anchor]');
      var featImg    = wrap.querySelector('[data-feat-img]');
      var featName   = wrap.querySelector('[data-feat-name]');
      var featPrice  = wrap.querySelector('[data-feat-price]');
      var featInfo   = wrap.querySelector('[data-feat-info]');
      var fill       = wrap.querySelector('.k-catalog-prog-fill');
      var cards      = wrap.querySelectorAll('.k-catalog-sm-card');
      var prevBtn    = wrap.querySelector('.k-catalog-prev');
      var nextBtn    = wrap.querySelector('.k-catalog-next');
      var total      = cards.length;
      var current    = 0;

      if (!total) return;

      /* ── Show 3 right-panel cards immediately after current, with optional slide ── */
      function showRightCards(direction) {
        if (window.innerWidth < 768) return; // mobile: CSS handles all cards
        cards.forEach(function (card, i) {
          var pos = i - current - 1; // 0 = next after featured, 1 = +2, 2 = +3
          if (pos >= 0 && pos < 3) {
            card.style.display = 'flex';
            card.style.order   = String(pos);
            if (direction !== 0) {
              // Restart CSS animation with staggered delay
              card.classList.remove('slide-from-right', 'slide-from-left');
              card.style.animationDelay = (pos * 60) + 'ms';
              void card.offsetWidth; // force reflow
              card.classList.add(direction > 0 ? 'slide-from-right' : 'slide-from-left');
            }
          } else {
            card.style.display = 'none';
            card.style.order   = '';
            card.classList.remove('slide-from-right', 'slide-from-left');
            card.style.animationDelay = '';
          }
        });
      }

      /* ── Update featured image + overlay with directional swap animation ── */
      function updateFeatured(idx, direction) {
        var src   = cards[idx] ? cards[idx].dataset.img   || '' : '';
        var name  = cards[idx] ? cards[idx].dataset.name  || '' : '';
        var price = cards[idx] ? cards[idx].dataset.price || '' : '';
        var url   = cards[idx] ? cards[idx].dataset.url   || '#' : '#';

        // direction=0: initial render — set content directly, no animation
        if (direction === 0) {
          if (featImg) {
            if (src) { featImg.src = src; featImg.alt = name; featImg.style.display = ''; }
            else { featImg.style.display = 'none'; }
          }
          if (featName)   featName.textContent  = name;
          if (featPrice)  featPrice.textContent  = price;
          if (featAnchor) featAnchor.href        = url;
          return;
        }

        // Directional swap:
        //   next (dir=1) → carousel scrolls right → featured enters from LEFT  (enterX = -20)
        //   prev (dir=-1) → carousel scrolls left → featured enters from RIGHT (enterX = +20)
        var exitX  =  direction * 20;  // image/text exits toward the travel direction
        var enterX = -direction * 20;  // new content enters from the opposite side

        // Phase 1 — slide out current content
        if (featImg) {
          featImg.style.transition = 'opacity .18s ease';
          featImg.style.opacity    = '0';
        }
        if (featInfo) {
          featInfo.style.transition = 'opacity .18s ease, transform .18s ease';
          featInfo.style.opacity    = '0';
          featInfo.style.transform  = 'translateX(' + exitX + 'px)';
        }

        setTimeout(function () {
          // Swap content
          if (featImg) {
            if (src) { featImg.src = src; featImg.alt = name; featImg.style.display = ''; }
            else { featImg.style.display = 'none'; }
          }
          if (featName)   featName.textContent  = name;
          if (featPrice)  featPrice.textContent  = price;
          if (featAnchor) featAnchor.href        = url;

          // Snap to entry origin (no transition)
          if (featImg)  { featImg.style.transition = 'none'; }
          if (featInfo) {
            featInfo.style.transition = 'none';
            featInfo.style.opacity    = '0';
            featInfo.style.transform  = 'translateX(' + enterX + 'px)';
          }
          // Force reflow so the snap registers before we animate in
          if (featImg)  void featImg.offsetWidth;
          if (featInfo) void featInfo.offsetWidth;

          // Phase 2 — slide in new content
          if (featImg) {
            featImg.style.transition = 'opacity .32s ease';
            featImg.style.opacity    = '1';
          }
          if (featInfo) {
            featInfo.style.transition = 'opacity .32s ease, transform .32s cubic-bezier(.25,.46,.45,.94)';
            featInfo.style.opacity    = '1';
            featInfo.style.transform  = 'translateX(0)';
          }
        }, 200);
      }

      /* ── Navigate to index ── */
      function goTo(idx, direction) {
        var dir = (direction !== undefined) ? direction : (idx >= current ? 1 : -1);
        current = Math.max(0, Math.min(total - 1, idx));
        updateFeatured(current, dir);
        showRightCards(dir);

        // Progress bar: 0% at start → 100% when last card is visible in right panel
        var maxCurrent = Math.max(1, total - 4);
        if (fill) fill.style.width = (total <= 4 ? 100 : Math.min(100, (current / maxCurrent) * 100)) + '%';

        // Hard stops: prev at first; next when last product is already in the right panel
        if (prevBtn) prevBtn.disabled = (current === 0);
        if (nextBtn) nextBtn.disabled = (current + 3 >= total - 1);
      }

      // Initialise without animation
      goTo(0, 0);

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1, -1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1,  1); });

      // Desktop: clicking a right card makes it the featured product
      cards.forEach(function (card, i) {
        card.addEventListener('click', function (e) {
          if (window.innerWidth >= 768) {
            e.preventDefault();
            goTo(i, i > current ? 1 : -1);
          }
        });
      });

      // Re-apply show/hide on resize (no animation)
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { showRightCards(0); }, 120);
      });
    });
  }

  /* ============================================================
     BOOT
  ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    updateModeUI(getMode());

    initHeader();
    initMobileMenu();
    initMobileSubmenus();
    initDropdowns();
    initModeToggle();
    initScrollAnimations();
    initStatsCounters();
    initHotspots();
    initCarouselDots();
    initHeroCTA();
    initSearch();
    initAccountPanel();
    initCartDrawer();
    initAddToCart();
    initProductCatalogs();
  });

  /* ============================================================
     SHOPIFY THEME EDITOR — re-init when sections/blocks change
  ============================================================ */
  document.addEventListener('shopify:section:load', function () {
    makeAllVisible();
    initMobileSubmenus();
    initDropdowns();
    initModeToggle();
    initHotspots();
    initCarouselDots();
    initProductCatalogs();
    initHeroCTA();
    initStatsCounters();
    initSearch();
    initAccountPanel();
    initCartDrawer();
  });

  document.addEventListener('shopify:section:reorder', function () {
    makeAllVisible();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    if (!el) return;
    el.classList.add('visible');
    el.querySelectorAll('.k-product-card, .k-stat-card, .k-trust-item, .k-room-canvas').forEach(function (child) {
      child.classList.add('visible');
    });
  });

})();
